// extracted by mini-css-extract-plugin
module.exports =  {"shiftDetailsCallOut":"_shiftDetailsCallOut--1Y_Nk"};